<template>
    <div class="baseInfo report">
        <div class="manage-main">
            <div class="rule">
                <Menu></Menu>
                <div class="manage-right report-manage">
                    <div>
                        <div class="head">
                            <div class="left">
                                <div class="select select-year">
                                    <span></span>
                                    <select v-model="CheckYearA">
                                        <option :value="Year+1">{{Year+1}} 年</option>
                                        <option :value="Year">{{Year}} 年</option>
                                        <option :value="Year-1">{{Year-1}} 年</option>
                                    </select>
                                </div>
                                <div class="title">
                                    入住订单统计
                                </div>
                            </div>
                        </div>
                        <div class="link"></div>
                        <div class="charts">
                            <div class="chart-btn">
                                <span :class="typeA == 'NRC'?'active':''" @click="checkType('NRC','A')">间夜数</span>
                                <span :class="typeA == 'OrderCount'?'active':''" @click="checkType('OrderCount','A')">订单数</span>
                                <span :class="typeA == 'Amount'?'active':''" @click="checkType('Amount','A')">订单金额</span>
                            </div>
                            <ve-histogram :data="chartDataA" :extend="extend" v-if="!isNoDataA&&!isLoadingA"></ve-histogram>
                            <div class="loading" v-if="isLoadingA">
                                <Loading :isLoading="isLoadingA"></Loading>
                            </div>
                            <div class="no-data" v-if="isNoDataA">
                                暂无数据...
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="head">
                            <div class="left">
                                <div class="select select-year">
                                    <span></span>
                                    <select v-model="CheckYearB">
                                        <option :value="Year+1">{{Year+1}} 年</option>
                                        <option :value="Year">{{Year}} 年</option>
                                        <option :value="Year-1">{{Year-1}} 年</option>
                                    </select>
                                </div>
                                <div class="title">
                                    预定订单统计
                                </div>
                            </div>
                        </div>
                        <div class="link"></div>
                        <div class="charts">
                            <div class="chart-btn">
                                <span :class="typeB == 'NRC'?'active':''" @click="checkType('NRC','B')">间夜数</span>
                                <span :class="typeB == 'OrderCount'?'active':''" @click="checkType('OrderCount','B')">订单数</span>
                                <span :class="typeB == 'Amount'?'active':''" @click="checkType('Amount','B')">订单金额</span>
                            </div>
                            <ve-histogram :data="chartDataB" :extend="extend" v-if="!isLoadingB&&!isNoDataB"></ve-histogram>
                            <div class="loading" v-if="isLoadingB">
                                <Loading :isLoading="isLoadingB"></Loading>
                            </div>
                            <div class="no-data" v-if="isNoDataB">
                                暂无数据...
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="head">
                            <div class="left">
                                <div class="select select-year">
                                    <span></span>
                                    <select v-model="CheckPieYear">
                                        <option :value="Year+1">{{Year+1}} 年</option>
                                        <option :value="Year">{{Year}} 年</option>
                                        <option :value="Year-1">{{Year-1}} 年</option>
                                    </select>
                                </div>
                                <div class="select select-month">
                                    <span></span>
                                    <select v-model="CheckPieMonth">
                                        <option v-for="item in 12" :value="item">{{item}} 月</option>
                                    </select>
                                </div>
                                <div class="title">
                                    入住/预订订单-天数跨度统计
                                </div>
                            </div>
                        </div>
                        <div class="link"></div>
                        <div class="charts">
                            <div class="pie">
                                <div class="title">入住天数的订单数占比 <br>(按入住时间统计)</div>
                                <ve-ring :data="chartPieDataA" :legend-visible="false" :settings="chartSettings" v-if="!isLoadingPieA&&!isNoDataPieA"></ve-ring>
                                <div class="loading" v-if="isLoadingPieA">
                                    <Loading :isLoading="isLoadingPieA"></Loading>
                                </div>
                                <div class="no-data" v-if="isNoDataPieA">
                                    暂无数据...
                                </div>
                            </div>
                            <div class="pie">
                                <div class="title">提前预订天数的订单数占比 <br>(按预定时间统计)</div>
                                <ve-ring :data="chartPieDataB" :legend-visible="false" :settings="chartSettings" v-if="!isLoadingPieB&&!isNoDataPieB"></ve-ring>
                                <div class="loading" v-if="isLoadingPieB">
                                    <Loading :isLoading="isLoadingPieB"></Loading>
                                </div>
                                <div class="no-data" v-if="isNoDataPieB">
                                    暂无数据...
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="head">
                            <div class="left">
                                <div class="select select-year">
                                    <span></span>
                                    <select v-model="CheckYearC">
                                        <option :value="Year+1">{{Year+1}} 年</option>
                                        <option :value="Year">{{Year}} 年</option>
                                        <option :value="Year-1">{{Year-1}} 年</option>
                                    </select>
                                </div>
                                <div class="title">
                                    TOP20
                                </div>
                                <div class="select" style="margin-left: 15px">
                                    <span></span>
                                    <select v-model="CheckArea" style="width: 125px">
                                        <option value="3">城 市</option>
                                        <option value="4">国家/地区</option>
                                    </select>
                                </div>
                                <div class="title">
                                    预订订单统计
                                </div>
                            </div>
                        </div>
                        <div class="link"></div>
                        <div class="charts">
                            <div class="chart-btn">
                                <span :class="typeC == 'NRC'?'active':''" @click="checkType('NRC','C')">间夜数</span>
                                <span :class="typeC == 'OrderCount'?'active':''" @click="checkType('OrderCount','C')">订单数</span>
                                <span :class="typeC == 'Amount'?'active':''" @click="checkType('Amount','C')">订单金额</span>
                            </div>
                            <ve-pie :data="chartDataC" v-if="!isLoadingPieC&&!isNoDataPieC" :settings="chartPieSettings" :extend="extendC"></ve-pie>
                            <div class="loading" v-if="isLoadingPieC">
                                <Loading :isLoading="isLoadingPieC"></Loading>
                            </div>
                            <div class="no-data" v-if="isNoDataPieC">
                                暂无数据...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from './comm/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    export default {
        name: "reportMonth",
        components: {
            Menu,
            Loading,
            DatePicker
        },
        data: function () {
            this.chartPieSettings = {        //汇总饼图设置
                radius: 140,
                limitShowNum: 20,
            },
            this.extendC = {       //汇总饼图指示图例配置
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                },
            },
            this.chartSettings = {   //环图配置
                radius: [90, 130],
                offsetY: 170
            },
            this.extend = {
                'xAxis.0.axisLabel.rotate': 0,
                series: {
                    label: {
                        normal: {
                            show: true
                        }
                    }
                },
                legend: {
                    x: 'right'
                },
            }
            return {
                chartDataC: {
                    columns: [],
                    rows: []
                },
                chartPieDataA: {
                    columns: [],
                    rows: []
                },
                chartPieDataB: {
                    columns: [],
                    rows: []
                },
                chartDataA: {
                    columns: [],
                    rows:[]
                },
                chartDataB: {
                    columns: [],
                    rows:[]
                },
                Year:new Date().getFullYear(),
                Month:new Date().getMonth()+1,
                //  A 代表是入住报表，B代表是预定报表,C代表年度汇总
                CheckYearA:new Date().getFullYear(),
                listA:[],
                typeA:'NRC',
                isLoadingA:false,
                isNoDataA:false,
                CheckYearB:new Date().getFullYear(),
                listB:[],
                typeB:'NRC',
                isLoadingB:false,
                isNoDataB:false,
                CheckPieYear:new Date().getFullYear(),
                CheckPieMonth:new Date().getMonth()+1,
                isNoDataPieA:false,
                isNoDataPieB:false,
                isLoadingPieA:false,
                isLoadingPieB:false,
                isNoDataPieC:false,
                isLoadingPieC:false,
                CheckArea:3,
                listC:[],
                CheckYearC:new Date().getFullYear(),
                typeC:'NRC',

            }
        },
        watch:{
            CheckYearA(key){
                this.initData('A');
            },
            CheckYearB(key){
                this.initData('B');
            },
            CheckYearC(key){
                this.getSummaryData();
            },
            CheckArea(key){
                this.getSummaryData();
            },
            CheckPieYear(key){
                this.getAdvanceDays();
                this.getNightCounts();
            },
            CheckPieMonth(key){
                this.getAdvanceDays();
                this.getNightCounts();
            }
        },
        mounted() {
            //请求入住订单柱状图
            this.initData('A');
            //请求预定订单柱状图
            this.initData('B');
            //请求连住天数预定订单
            this.getAdvanceDays();
            //请求连住晚数数入住订单
            this.getNightCounts();
            //请求区域订单汇总
            this.getSummaryData();
            document.title='月看板---订房易';
        },
        methods: {
            //报表视图切换事件
            checkType(type,datetype){
                if(datetype == 'A'){
                    this.typeA = type;
                    this.formatChart(this.listA,datetype,type);
                }else if(datetype == 'B'){
                    this.typeB = type;
                    this.formatChart(this.listB,datetype,type);
                }else if(datetype == 'C'){
                    this.typeC = type;
                    this.formatChart(this.listC,datetype,type);
                }
            },
            //格式化X轴月份显示
            formatMonth(v){
                switch (v.charAt(4)+v.charAt(5)){
                    case '01':
                        return '1月';
                    case '02':
                        return '2月';
                    case '03':
                        return '3月';
                    case '04':
                        return '4月';
                    case '05':
                        return '5月';
                    case '06':
                        return '6月';
                    case '07':
                        return '7月';
                    case '08':
                        return '8月';
                    case '09':
                        return '9月';
                    case '10':
                        return '10月';
                    case '11':
                        return '11月';
                    case '12':
                        return '12月';
                }
            },

            manageData(list,type){
                var row = [];
                var column = [];
                if(type === 'NRC'){
                    for(let i = 0; i < list.length; i++){
                        var arr = {
                            日期: list[i].Tag,
                            间夜数: list[i].NRC
                        }
                        row.push(arr)
                    }
                    column = ['日期','间夜数'];
                }else if(type === 'OrderCount'){
                    for(let i = 0; i < list.length; i++){
                        var arr = {
                            日期: list[i].Tag,
                            订单数: list[i].OrderCount
                        }
                        row.push(arr)
                    }
                    column = ['日期','订单数'];
                }else if(type === 'Amount'){
                    for(let i = 0; i < list.length; i++){
                        var arr = {
                            日期: list[i].Tag,
                            订单金额: list[i].Amount
                        }
                        row.push(arr)
                    }
                    column =['日期','订单金额'];
                }
                var data = {
                    row:row,
                    column:column
                }
                return data;
            },
            //格式化显示数据格式：A为入住订单柱状图，B为预定订单柱状图，C为区域订单汇总饼图
            formatChart(list,datetype,type){
                if(datetype == 'A'){
                    this.isNoDataA = false;
                    var data = this.manageData(list,type)
                    if(data.row.length == 0){
                        this.isNoDataA = true;
                    }
                    this.chartDataA = {
                        columns: data.column,
                        rows:data.row
                    }
                }else if(datetype == 'B'){
                    this.isNoDataB = false;
                    var data = this.manageData(list,type)
                    if(data.row.length == 0){
                        this.isNoDataB = true;
                    }
                    this.chartDataB = {
                        columns: data.column,
                        rows:data.row
                    }
                }else if(datetype == 'C'){
                    var rows = [];
                    var columns = [];
                    this.isNoDataPieC = false;
                    if(type === 'NRC'){
                        for(let i = 0; i < list.length; i++){
                            var arr = {
                                地区:  list[i].Tag,
                                间夜数: list[i].NRC
                            }
                            rows.push(arr)
                        }
                        columns = ['地区','间夜数']
                    }else if(type === 'OrderCount'){
                        for(let i = 0; i < list.length; i++){
                            var arr = {
                                地区: list[i].Tag,
                                订单数: list[i].OrderCount
                            }
                            rows.push(arr)
                        }
                        columns = ['地区','订单数']
                    }else if(type === 'Amount'){
                        for(let i = 0; i < list.length; i++){
                            var arr = {
                                地区: list[i].Tag,
                                订单金额: list[i].Amount
                            }
                            rows.push(arr)
                        }
                        columns = ['地区','订单金额']
                    }
                    if(rows.length == 0){
                        this.isNoDataPieC = true;
                    }
                    this.chartDataC = {
                        columns: columns,
                        rows:rows
                    }
                }

            },
            //格式化每月入住和预定订单环图
            formatPieChart(list,datetype){
                if(datetype == 'A'){
                    var row = [];
                    this.isNoDataPieA = false;
                    for(var item in list){
                        var j = {
                            '连住天数类型':item,
                            '数量':list[item]
                        }
                        row.push(j)
                    }
                    if(row.length == 0){
                        this.isNoDataPieA = true;
                    }
                    this.chartPieDataA = {
                        columns: ['连住天数类型', '数量'],
                        rows: row
                    }
                }else{
                    var row = [];
                    this.isNoDataPieB = false;
                    for(var item in list){
                        var j = {
                            '连住天数类型':item,
                            '数量':list[item]
                        }
                        row.push(j)
                    }
                    if (row.length == 0){
                        this.isNoDataPieB = true
                    }
                    this.chartPieDataB = {
                        columns: ['连住天数类型', '数量'],
                        rows: row
                    }
                }
            },
            //去除名称前面的年份
            formatCity(lis){
                var list = lis;
                var subStr=new RegExp(this.CheckYearC+' ');
                for (let i = 0; i<list.length; i++){
                    list[i].Tag = list[i].Tag.replace(subStr,'');
                  // if(list[i].Tag) {
                  //   list[i].Tag = list[i].Tag.replace(subStr,'');
                  // }
                }
                return list
            },
            //获取每月天数
            getDates(y,m){
                var d = new Date(y, m, 0);
                return d.getDate();
            },
            getMonth(y,m){
                if(m==12){
                    return (y+1)+'-01'
                }else{
                    return y+'-'+(m+1<10?"0"+(m+1):m+1)
                }
            },
            //请求连住天数预定订单
            getAdvanceDays(){
                var that = this;
                that.isLoadingPieB = true
                var params = {
                    Start:that.CheckPieYear+'-'+ this.CheckPieMonth +'-01',
                    End:that.getMonth(parseInt(that.CheckPieYear),parseInt(this.CheckPieMonth))+'-01',
                }
                that.postRequest({
                    url:that.Api.getAdvanceDays,
                    params:params
                }).then(res => {
                    that.isLoadingPieB = false;
                    if (res && res.IsSuccess) {
                        that.formatPieChart(res.Result,'B')
                    } else {
                        // $state.complete();
                    }
                })
            },
            //请求连住晚数数入住订单
            getNightCounts(){
                var that = this;
                that.isLoadingPieA = true;
                var params = {
                    Start:that.CheckPieYear+'-'+ this.CheckPieMonth +'-01',
                    End:that.getMonth(parseInt(that.CheckPieYear),parseInt(this.CheckPieMonth))+'-01',
                }
                that.postRequest({
                    url:that.Api.getNightCounts,
                    params:params
                }).then(res => {
                    that.isLoadingPieA = false;
                    if (res && res.IsSuccess) {
                        that.formatPieChart(res.Result,'A')
                    } else {
                        // $state.complete();
                    }
                })
            },
            getMomth(v){
              return  v.charAt(4)+v.charAt(5)
            },
            completionDate(list,year){
                var list = list;
                if(list.length!=12){
                    for (let i = 0; i<12; i++){
                        var a = true
                        var m = i<9?'0'+(i+1):(i+1)+'';
                        for (let j = 0; j<list.length; j++){
                            if(this.getMomth(list[j].Tag) == m){
                                a = false;
                                list[j].Tag = list[j].Tag
                            }
                        }
                        if(a){
                            var arr = {
                                Amount: 0,
                                NRC: 0,
                                OrderCount: 0,
                                Tag: year+m
                            }
                            list.splice(i,0,arr)
                        }
                    }
                }
                list.sort(function(a,b){
                    return a.Tag - b.Tag;
                })
                for (let i=0; i<list.length; i++){
                    list[i].Tag = this.formatMonth(list[i].Tag)
                }
                return list
            },
            //请求入住订单柱状图（A），请求预定订单柱状图(B)
            initData(type){
                var that = this;
                if(type == 'A'){
                    that.isLoadingA = true;
                    var params = {
                        Start:that.CheckYearA+'-01-01',
                        End:that.CheckYearA+'-12-31',
                        DateType:1,
                        GroupType:1,
                    }
                    that.postRequest({
                        url:that.Api.getReport,
                        params:params
                    }).then(res => {
                        that.isLoadingA = false;
                        if (res && res.IsSuccess) {
                            that.listA = that.completionDate(res.Result,that.CheckYearA)
                            that.formatChart(that.listA,'A',that.typeA)
                        } else {
                            // $state.complete();
                        }
                    })
                }else if(type == 'B'){
                    that.isLoadingB = true;
                    var params = {
                        Start:that.CheckYearB+'-01-01',
                        End:that.CheckYearB+'-12-31',
                        DateType:0,
                        GroupType:1,
                    }
                    that.postRequest({
                        url:that.Api.getReport,
                        params:params
                    }).then(res => {
                        that.isLoadingB = false;
                        if (res && res.IsSuccess) {
                            that.listB = that.completionDate(res.Result,that.CheckYearB)
                            that.formatChart(that.listB,'B',that.typeB)
                        } else {
                            // $state.complete();
                        }
                    })
                }
            },
            //请求区域订单汇总
            getSummaryData(){
               var that = this;
               that.isLoadingPieC = true;
                var params = {
                    Start:that.CheckYearC+'-01-01',
                    End:that.CheckYearC+'-12-31',
                    DateType:0,
                    GroupType:that.CheckArea,
                }
                that.postRequest({
                    url:that.Api.getReport,
                    params:params
                }).then(res => {
                    that.isLoadingPieC = false;
                    if (res && res.IsSuccess) {
                        that.listC = that.formatCity(res.Result)
                        that.formatChart(that.listC,'C',that.typeC)
                    } else {
                        // $state.complete();
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/report/ReportMonth.vue